import type { ViewKey } from './state.js';
import { escapeHtml } from './format.js';

export type NavigationGroupKey = 'overview' | 'guests' | 'salon' | 'finance' | 'system';

export const navigationGroups: Array<{ key: NavigationGroupKey; label: string }> = [
  { key: 'overview', label: 'Genel' },
  { key: 'guests', label: 'Müşteri & Randevu' },
  { key: 'salon', label: 'Salon' },
  { key: 'finance', label: 'Finans' },
  { key: 'system', label: 'Sistem' }
];

export const navigationItems: Array<{ key: ViewKey; label: string; icon: string; group: NavigationGroupKey; hint: string }> = [
  { key: 'dashboard', label: 'Dashboard', icon: '⌂', group: 'overview', hint: 'Günün özeti' },
  { key: 'appointments', label: 'Randevular', icon: '◫', group: 'guests', hint: 'Randevu takvimi' },
  { key: 'clients', label: 'Müşteriler', icon: '◎', group: 'guests', hint: 'Müşteri yönetimi' },
  { key: 'catalog', label: 'Stil Kataloğu', icon: '✦', group: 'salon', hint: 'Dijital stil menüsü' },
  { key: 'operations', label: 'Operasyon', icon: '◇', group: 'salon', hint: 'Günlük operasyon' },
  { key: 'employees', label: 'Çalışanlar', icon: '☺', group: 'salon', hint: 'Personel, izin takvimi, maaş & hakediş' },
  { key: 'inventory', label: 'Stok & Ürünler', icon: '▤', group: 'salon', hint: 'Stok, ürünler ve tedarik' },
  { key: 'checkout', label: 'Satış / Ödeme', icon: '₺', group: 'finance', hint: 'Satış & ödeme' },
  { key: 'business', label: 'İşletme', icon: '▦', group: 'finance', hint: 'Giderler, kasa, personel ve görevler' },
  { key: 'reports', label: 'Raporlar', icon: '⌁', group: 'finance', hint: 'Özet raporlar' },
  { key: 'settings', label: 'Ayarlar', icon: '⚙', group: 'system', hint: 'Salon ayarları' }
];

const itemHtml = (item: (typeof navigationItems)[number], active: ViewKey): string =>
  `<button type="button" class="nav-button ${item.key === active ? 'active' : ''}" data-view="${item.key}" title="${escapeHtml(item.hint)}" aria-current="${item.key === active ? 'page' : 'false'}"><span class="nav-icon" aria-hidden="true">${escapeHtml(item.icon)}</span><span class="nav-label">${escapeHtml(item.label)}</span></button>`;

export function navigationHtml(active: ViewKey): string {
  const groups = navigationGroups.filter((group) => group.key !== 'system').map((group) => {
    const items = navigationItems.filter((item) => item.group === group.key);
    return `<section class="nav-group" data-nav-group="${group.key}"><span class="nav-group-label">${escapeHtml(group.label)}</span><div class="nav-group-items">${items.map((item) => itemHtml(item, active)).join('')}</div></section>`;
  }).join('');
  const system = navigationItems.filter((item) => item.group === 'system').map((item) => itemHtml(item, active)).join('');
  return `${groups}<div class="nav-settings-fixed">${system}</div>`;
}
